import { IComponentOptions } from 'angular';
import { ManageUsersFiltersCtrl } from './manage-users-filters.controller';

export const ManageUsersFiltersComponent: IComponentOptions = {
  bindings: {
    users: '<',
  },
  controller: ManageUsersFiltersCtrl,
  template: require('./manage-users-filters.html'),
};
